import { render, staticRenderFns } from "./StayForms.vue?vue&type=template&id=64d32aa4&scoped=true"
import script from "./StayForms.vue?vue&type=script&lang=js"
export * from "./StayForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d32aa4",
  null
  
)

export default component.exports